import React from 'react';
import { Button, CustomInput, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';

const initialValues = {
  temperature: 2.90,
  temperatureLag: 2.97,
  precipitation: 1.83,
  windSpeed: 2.26,
  sunshineDuration: 6.76,
  sunshineDurationLag: 6.76,
  relativeHumidity: 61.62,
  relativeHumidityLag: 61.62,
  pressure: 667.44,
  heatIndexLag: 2.42,
  selectModel: 1,
  predictValue: 3.35
}

class RegressionPredictor extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialValues;
    this.getNewPredictValue = this.getNewPredictValue.bind(this);
    this.changeSelectModel = this.changeSelectModel.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  getNewPredictValue(changeModel = 0) {
    var scaleTemperature = (parseFloat(this.state.temperature) - 2.896025) / 6.968294;
    var scaleTemperatureLag = (parseFloat(this.state.temperatureLag) - 2.966477) / 6.930442;
    var scalePrecipitation = (parseFloat(this.state.precipitation) - 1.83163) / 1.832435;
    var scaleWindSpeed = (parseFloat(this.state.windSpeed) - 2.262661) / 0.3110057;
    var scaleSunshineDuration = (parseFloat(this.state.sunshineDuration) - 6.755905) / 1.174667;
    var scaleSunshineDurationLag = (parseFloat(this.state.sunshineDurationLag) - 6.751526) / 1.176913;
    var scaleRelativeHumidity = (parseFloat(this.state.relativeHumidity) - 61.62331) / 13.26626;
    var scaleRelativeHumidityLag = (parseFloat(this.state.relativeHumidityLag) - 61.70952) / 13.26044;
    var scalePressure = (parseFloat(this.state.pressure) - 667.4352) / 3.040168;
    var scaleHeatIndexLag = (parseFloat(this.state.heatIndexLag) - 2.485298) / 6.519566;    
    var newPredictValue = 0;
    var selectModel = this.state.selectModel;
    if (changeModel !== 0) {
      selectModel = parseInt(changeModel);
    }
    if (selectModel === 1) {
      newPredictValue = Math.exp(1.2054024 + scaleTemperature * 0.3922754 + scalePrecipitation * 0.2075393 - scaleWindSpeed * 0.3346116 + scaleSunshineDuration * 0.1237804 - scaleRelativeHumidity * 0.2665482)
    } else if (selectModel === 2) {
      newPredictValue = Math.exp(1.19956990 + scaleTemperature * 0.25901702 + scalePrecipitation * 0.17877509 - scaleWindSpeed * 0.23005129 + scaleSunshineDuration * 0.10909639 - scaleRelativeHumidity * 0.37351520 - scalePressure * 0.19330744 + scaleTemperatureLag * 0.35831765 + scaleSunshineDurationLag * 0.08465429 + scaleRelativeHumidityLag * 0.17399368)
    } else {
      newPredictValue = Math.exp(1.2117044 + scalePrecipitation * 0.1724875 - scaleWindSpeed * 0.1597815 + scaleSunshineDuration * 0.1928151 - scalePressure * 0.2260822 + scaleHeatIndexLag * 0.4715218)
    }
    return newPredictValue;
  }

  changeSelectModel(event) {
    var target = event.target;
    var newPredictValue = this.getNewPredictValue(target.value);
    this.setState({
      selectModel: parseInt(target.value),
      predictValue: newPredictValue.toFixed(2)
    });
  }

  handleSubmit(event) {
    var newPredictValue = this.getNewPredictValue();
    this.setState({
      predictValue: newPredictValue.toFixed(2)
    });
  }

  handleInputChange(event) {
    const target = event.target;
    console.log(target.name);
    this.setState({
      [target.name]: target.value
    });
    this.handleSubmit(event);
  }

  resetForm(event) {
    this.setState(initialValues)
  }

  render() {
    return (
      <Form>
        <Row>
          <Col sm="12" md={{ size: 4, offset: 4 }}>
            <FormGroup>
              <Label><h5>Selected Model</h5></Label>
              <Input type="select" name="select-model" onChange={this.changeSelectModel}>
                <option value={1}>1. Only meteorological factors</option>
                <option value={2}>2. With lag factors</option>
                <option value={3}>3. With HI and lag factors</option>
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row style={{ marginBottom: '20px' }}>
          <Col sm="12" md={{ size: 6, offset: 3 }} align="center">
            <span className="lead" style={{fontSize: '24px'}}>Predict monthly cases: <b>{this.state.predictValue}</b></span>
          </Col>
        </Row>
        <Row>
          <Col md={{ size: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0" disabled={true}>
              <Label className="mr-sm-2"><font size = "4">Air temperature (°C)</font></Label>
              <CustomInput type="range" step="0.01" min="-40" max="40" name="temperature" onChange={this.handleInputChange} value={this.state.temperature} disabled={this.state.selectModel === 3} />
              <Input type="number" step="0.01" min="-40" max="40" name="temperature" onChange={this.handleInputChange} value={this.state.temperature} disabled={this.state.selectModel === 3} />
            </FormGroup>
          </Col>
          <Col md={{ size: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0" disabled={true}>
              <Label className="mr-sm-2"><font size = "4">Lag air temperature (°C)</font></Label>
              <CustomInput type="range" step="0.01" min="-40" max="40" name="temperatureLag" onChange={this.handleInputChange} value={this.state.temperatureLag} disabled={this.state.selectModel !== 2} />
              <Input type="number" step="0.01" min="-40" max="40" name="temperatureLag" onChange={this.handleInputChange} value={this.state.temperatureLag} disabled={this.state.selectModel !== 2} />
            </FormGroup>
          </Col>
          <Col md={{ size: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Label className="mr-sm-2"><font size = "4">Relative humidity (%)</font></Label>
              <CustomInput type="range" step="0.01" min="0" max="100" name="relativeHumidity" onChange={this.handleInputChange} value={this.state.relativeHumidity} disabled={this.state.selectModel === 3} />
              <Input type="number" step="0.01" min="0" max="100" name="relativeHumidity" onChange={this.handleInputChange} value={this.state.relativeHumidity} disabled={this.state.selectModel === 3} />
            </FormGroup>
          </Col>
          <Col md={{ size: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Label className="mr-sm-2"><font size = "4">Lag relative humidity (%)</font></Label>
              <CustomInput type="range" step="0.01" min="0" max="100" name="relativeHumidityLag" onChange={this.handleInputChange} value={this.state.relativeHumidityLag} disabled={this.state.selectModel !== 2} />
              <Input type="number" step="0.01" min="0" max="100" name="relativeHumidityLag" onChange={this.handleInputChange} value={this.state.relativeHumidityLag} disabled={this.state.selectModel !== 2} />
            </FormGroup>
          </Col>
        </Row>
        <Row style={{ marginTop: '15px' }}>
          <Col md={{ size: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Label className="mr-sm-2"><font size = "4">Daily precipitation (mm)</font></Label>
              <CustomInput type="range" step="0.01" min="0" max="20" name="precipitation" onChange={this.handleInputChange} value={this.state.precipitation} />
              <Input type="number" step="0.01" min="0" max="20" name="precipitation" onChange={this.handleInputChange} value={this.state.precipitation} />
            </FormGroup>
          </Col>
          <Col md={{ size: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Label className="mr-sm-2"><font size = "4">Wind speed (m/s)</font></Label>
              <CustomInput type="range" step="0.01" min="0" max="10" name="windSpeed" onChange={this.handleInputChange} value={this.state.windSpeed} />
              <Input type="number" step="0.01" min="0" max="10" name="windSpeed" onChange={this.handleInputChange} value={this.state.windSpeed} />
            </FormGroup>
          </Col>
          <Col md={{ size: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Label className="mr-sm-2"><font size = "4">Sunshine duration (h)</font></Label>
              <CustomInput type="range" step="0.01" min="0" max="20" name="sunshineDuration" onChange={this.handleInputChange} value={this.state.sunshineDuration} />
              <Input type="number" step="0.01" min="0" max="20" name="sunshineDuration" onChange={this.handleInputChange} value={this.state.sunshineDuration} />
            </FormGroup>
          </Col>
          <Col md={{ size: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Label className="mr-sm-2"><font size = "4">Lag sunshine duration (h)</font></Label>
              <CustomInput type="range" step="0.01" min="0" max="20" name="sunshineDurationLag" onChange={this.handleInputChange} value={this.state.sunshineDurationLag} disabled={this.state.selectModel !== 2} />
              <Input type="number" step="0.01" min="0" max="20" name="sunshineDurationLag" onChange={this.handleInputChange} value={this.state.sunshineDurationLag} disabled={this.state.selectModel !== 2} />
            </FormGroup>
          </Col>
        </Row>
        <Row style={{ marginTop: '15px' }}>
          <Col md={{ size: 3, offset: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Label className="mr-sm-2"><font size = "4">Pressure (hPa)</font></Label>
              <CustomInput type="range" step="0.01" min="650" max="750" name="pressure" onChange={this.handleInputChange} value={this.state.pressure} disabled={this.state.selectModel === 1} />
              <Input type="number" step="0.01" min="650" max="750" name="pressure" onChange={this.handleInputChange} value={this.state.pressure} disabled={this.state.selectModel === 1} />
            </FormGroup>
          </Col>
          <Col md={{ size: 3 }}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Label className="mr-sm-2"><font size = "4">Lag heat index (°C)</font></Label>
              <CustomInput type="range" step="0.01" min="-50" max="50" name="heatIndexLag" onChange={this.handleInputChange} value={this.state.heatIndexLag} disabled={this.state.selectModel !== 3} />
              <Input type="number" step="0.01" min="-50" max="50" name="heatIndexLag" onChange={this.handleInputChange} value={this.state.heatIndexLag} disabled={this.state.selectModel !== 3} />
            </FormGroup>
          </Col>
        </Row>
        <Row style={{ marginTop: '20px' }}>
          <Col sm="12" md={{ size: 4, offset: 4 }} align="center">
            <Button type='reset' block outline color="secondary" onClick={this.resetForm}>Reset</Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default RegressionPredictor;